// Footer.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

const Footer: React.FC = () => {
  return (
    <Box component="footer" sx={{ marginTop: 'auto', padding: '16px', backgroundColor: '#f8f8f8', textAlign: 'center' }}>
      <Typography variant="body2" color="textSecondary">
        <Link to="/privacy-policy" style={{ marginRight: '16px' }}>
          Privacy Policy
        </Link>
        <Link to="/terms-of-service">
          Terms of Service
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer;
